<template>
  <rest-list-action
    icon="el-icon-delete"
    :title="$t(title)"
    :click="click"
    :data-qa="dataQa"
  />
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListAction from '@/common/components/rest/RestListAction'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'RestListActionDelete',
  components: { RestListAction },
  inject: ['restList'],

  props: {
    endpoint: {
      type: Object,
      required: true
    },

    name: {
      type: String,
      required: false
    },

    deleteMessage: {
      type: [Function, String],
      required: false
    },

    htmlWarningMsg: {
      type: Boolean,
      required: false,
      default: false
    },
    clearMask: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: 'RestList_Action_Delete'
    },
    dataQa: {
      type: String,
      required: false,
      default: 'delete-action-button'
    }
  },

  methods: {
    async click() {
      let msg = this.deleteMessage
      if (this.deleteMessage && typeof this.deleteMessage === 'function') {
        msg = await this.deleteMessage()
      }
      const confirmButtonHookClass = 'restlist-delete-confirm-hook'
      const cancelButtonHookClass = 'restlist-delete-cancel-hook'

      this.$msgbox({
        title: this.$t('RestList_DeleteTitle'),
        message: msg || this.$t('RestList_DeletePrompt', { label: this.name }),
        showCancelButton: true,
        confirmButtonText: this.$t('RestList_DeleteConfirmButton'),
        cancelButtonText: this.$t('RestList_DeleteCancelButton'),
        center: true,
        dangerouslyUseHTMLString: this.htmlWarningMsg,
        confirmButtonClass: confirmButtonHookClass,
        cancelButtonClass: cancelButtonHookClass
      })
        .then(() => {
          RestApi(this.endpoint)
            .then(() => {
              this.$message({
                message: this.$t('RestList_DeleteSuccessMessage'),
                type: 'success',
                dangerouslyUseHTMLString: this.htmlWarningMsg
              })
              this.restList.refresh()

              if (typeof this.endpoint.handler === 'function') {
                this.endpoint.handler()
              }
            })
            .catch(error => {
              this.$message({
                message: error.message,
                type: 'error',
                dangerouslyUseHTMLString: this.htmlWarningMsg
              })
            })
        })
        .finally(() => {
          if (this.clearMask) {
            document.querySelector('.v-modal').remove()
            EventBus.$emit('applyLabels', null)
          }
        })
      this.$nextTick(() => {
        const msgBoxContainer = document.querySelector('.el-message-box')
        if (msgBoxContainer) {
          const confirmBtn = msgBoxContainer.querySelector(
            `.${confirmButtonHookClass}`
          )
          if (confirmBtn) {
            confirmBtn.setAttribute('data-qa', 'modal-delete-button')
          }
          const cancelBtn = msgBoxContainer.querySelector(
            `.${cancelButtonHookClass}`
          )
          if (cancelBtn) {
            cancelBtn.setAttribute('data-qa', 'modal-cancel-button')
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListActionDelete.vue